import { useMemo } from 'react';
import { Button } from '../../button/index.js';
import { ModalFooterSpecializedActionsContainer, ModalFooterContainer } from './styles.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const ModalFooter = _ref => {
  let {
    size,
    className,
    children,
    isMobile,
    primaryButtonProps,
    secondaryButtonProps
  } = _ref;
  const primaryAction = useMemo(() => {
    return primaryButtonProps ? /*#__PURE__*/jsx(Button, {
      ...primaryButtonProps,
      fullWidth: isMobile
    }) : null;
  }, [primaryButtonProps]);
  const secondaryAction = useMemo(() => {
    return secondaryButtonProps ? /*#__PURE__*/jsx(Button, {
      ...secondaryButtonProps,
      variant: "minor",
      fullWidth: isMobile
    }) : null;
  }, [secondaryButtonProps]);
  const specializedActions = useMemo(() => {
    return secondaryButtonProps || primaryButtonProps ? /*#__PURE__*/jsxs(ModalFooterSpecializedActionsContainer, {
      size: size,
      isMobile: isMobile,
      children: [secondaryAction, primaryAction]
    }) : null;
  }, [primaryButtonProps, secondaryButtonProps, isMobile, size]);
  return /*#__PURE__*/jsxs(ModalFooterContainer, {
    size: size,
    isMobile: isMobile,
    className: className,
    children: [children, specializedActions]
  });
};

export { ModalFooter };
//# sourceMappingURL=components.js.map
